import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pie-pagina',
  templateUrl: 'pie-pagina.component.html'
})
export class PiePaginaComponent {
  constructor() {
  }
  currentYear: number = new Date().getFullYear();
}
